import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ResourcesSidebar from './components/ResourcesSidebar';
import CanonicalLink from './components/CanonicalLink';
import Home from './pages/Home';
import HtmlPage from './pages/HtmlPage';
import CssPage from './pages/CssPage';
import JavascriptPage from './pages/JavascriptPage';
import BootstrapPage from './pages/BootstrapPage';
import About from './pages/About';
import VSCodePage from './pages/VSCodePage';
import SemanticHTMLPage from './pages/SemanticHTMLPage';
import MongoDBPage from './pages/MongoDBPage';
import InspirationPage from './pages/InspirationPage';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  // Determine if we're in development or production
  // Since we are using a custom domain at the root (codie.codes), we don't need a basename
  const basename = '';

  return (
    <ThemeProvider>
      <Router basename={basename}>
        <CanonicalLink />
        <div className="d-flex min-vh-100 position-relative">
          <ResourcesSidebar />
          <div className="flex-grow-1 d-flex flex-column">
            <Navbar />
            <div className="container-fluid flex-grow-1">
              <div className="row">
                <div className="col-12 mt-3">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/html" element={<HtmlPage />} />
                    <Route path="/css" element={<CssPage />} />
                    <Route path="/javascript" element={<JavascriptPage />} />
                    <Route path="/bootstrap" element={<BootstrapPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/vscode" element={<VSCodePage />} />
                    <Route path="/semantic-html" element={<SemanticHTMLPage />} />
                    <Route path="/mongodb" element={<MongoDBPage />} />
                    <Route path="/inspiration" element={<InspirationPage />} />
                  </Routes>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;